import React, { useState } from "react";

import { Button as AntButton, Col, Form, Row, Space, message } from "antd";

import { useForm } from "react-hook-form";

import axios from "axios";

import { useDispatch } from "react-redux";

import { useSelector } from "react-redux";

import { useParams } from "react-router";

import { apiV1Endpoint } from "../../../../api/v1";
import { DateField, InputField } from "../../../atoms/FormElement";
import { changeFieldFormatter, changeFieldParser } from "./utils";
import dayjs from "dayjs";
import Button from "../../../molecules/Button";
import { UploadDocument } from "../../../molecules/Documents";
import { RefreshRenwalData } from "../ducks/actions";
import { DATE_FORMATS, formatDateByType } from "../../../libs/utils";

export default (props) => {
  const {
    control,
    setValue,
    handleSubmit,
    getValues,
    formState: { errors },
  } = useForm();

  // redux states
  const { bookingDetails } = useSelector((state: any) => state.newBooking);

  const { leaseId = bookingDetails.leaseId } = useParams();

  const [isLoading, setIsLoading] = useState(false);
  const [transactionDate, setTransactionDate] = useState(
    dayjs(bookingDetails?.torReportLatestDate ?? new Date(Date.now()))
  );

  const dispatch: any = useDispatch();

  const onSubmit = async (data) => {
    try {
      setIsLoading(true);
      let payLoad = {
        leaseId: leaseId,
        transactionDate: formatDateByType(data?.transactionDate, "api"),
        salesValue: data?.salesValue,
      };
      if (data?.document?.documentId) {
        payLoad["attachment"] = data?.document?.documentId;
      }
      const response = await axios.post(`${apiV1Endpoint}/booking/turnoverReport`, payLoad);

      if (response?.data?.code === 201) {
        setIsLoading(false);
        message.success("submitted successfully!");
        dispatch(RefreshRenwalData());
      }

      props.parentState({ modalPayload: { open: false } });
    } catch (error) {
      setIsLoading(false);
      console.error("Error", error?.response?.data?.error);
      message.error(error?.response?.data?.error ?? "please try again.");
    }
  };

  return (
    <Form layout="vertical" name="bookingform" scrollToFirstError className="bf-main" onFinish={handleSubmit(onSubmit)}>
      <Row gutter={24}>
        <Col span={12}>
          <DateField
            label="Date"
            isRequired={true}
            fieldname={`transactionDate`}
            value={transactionDate}
            control={control}
            iProps={{ format: DATE_FORMATS.display, placeholder: DATE_FORMATS.display }}
            initValue={transactionDate}
            setValue={setValue}
            rules={{ required: "Please select date" }}
            validate={errors?.transactionDate && errors?.transactionDate && "error"}
            validMessage={errors?.transactionDate && errors?.transactionDate?.message}
          />
        </Col>
        <Col span={12}>
          <InputField
            isRequired={true}
            fieldname={`salesValue`}
            label="Sales Value"
            control={control}
            iProps={{
              type: "number",
              placeholder: "Sales Value",
              min: 0,
              parser: (value: any) => changeFieldParser(value, "amount"),
              formatter: (value: string): any => changeFieldFormatter(value, "amount"),
            }}
            rules={{ required: "Sale is required" }}
            validate={errors?.salesValue && "error"}
            validMessage={Object.entries(errors).length > 0 && errors?.salesValue && errors?.salesValue?.message}
          />
        </Col>
        <Col span={24}>
          <UploadDocument fieldname="document" label="Attachment" control={control} maxSize={10} />
        </Col>
      </Row>

      {!props?.parentState ? (
        <Row gutter={24} justify="space-between" style={{ marginTop: "15px" }}>
          <Col>
            <AntButton size="large" onClick={props.onClose}>
              Back
            </AntButton>
          </Col>
          <Col>
            <AntButton className="ef-approve-btn" htmlType="submit" disabled={isLoading}>
              {isLoading ? "Loading..." : "Save"}
            </AntButton>
          </Col>
        </Row>
      ) : (
        <Row gutter={24} className="footer">
          <Space size="middle">
            <Button
              label="Cancel"
              className="bf-discard-button"
              onClick={() => props.parentState({ modalPayload: { open: false } })}
            />

            <Button type="submit" label={isLoading ? "Loading..." : "Save"} className="cc-fotter_next-button" />
          </Space>
        </Row>
      )}
    </Form>
  );
};
